import { render, staticRenderFns } from "./TradeInstrumentView.vue?vue&type=template&id=ed910f52&scoped=true&"
import script from "./TradeInstrumentView.vue?vue&type=script&lang=ts&"
export * from "./TradeInstrumentView.vue?vue&type=script&lang=ts&"
import style0 from "./TradeInstrumentView.vue?vue&type=style&index=0&id=ed910f52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed910f52",
  null
  
)

export default component.exports